import React from "react";
import "./Footer.scss";

const Footer = () => {
  return <div className="footer">@2023 Shopcart made by Noel Jose</div>;
};

export default React.memo(Footer);
